import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { ApplicationPrintPage } from '@/features/deals';

export const Route = createFileRoute('/_print/deals/$dealId/application/print')({
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'deal.view', 'Deals'),
  component: function PrintApplication() {
    const { dealId } = Route.useParams();
    return <ApplicationPrintPage dealId={dealId} />;
  },
});
